<template>
  <textarea 
    ref="chatinput" 
    rows="1" 
    :value="value"
    v-on:input="updateValue($event.target.value)"
    @keydown.enter.exact.prevent
    @keyup.enter.exact="sendMessage($event)"
    @keydown.enter.shift.exact="newline"
    @focus="signalScrollToWebview"
    aria-label="Chat Input"
    class="global-chat-text-input"
    tabindex="0"
  >
  </textarea>
</template>

<script>

export default {
  props: ["value"],
  data: function () {
    return {
      inputText: this.value
    }
  },

  methods: {
    resizeTextarea() {
      this.$refs.chatinput.style.height = "auto";
      this.$refs.chatinput.style.height = this.$refs.chatinput.scrollHeight + "px";
    },
    
    resetTextarea() {
      // this.$el.style.height = "auto";
      this.$nextTick(() => {
        this.$el.setAttribute(
          "style",
          "height: auto"
        );
      });
    },
  
    newline () {
    },

    signalScrollToWebview () {
      const isWebview =  ('ReactNativeWebView' in window)
      if (!isWebview) {
        console.log('not in webview')
        return
      }
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'SCROLL_KEYBOARD_BOTTOM'
      }))
    },
    
    sendMessage (event) {
      if (event.shiftKey) return
      event.preventDefault()
      this.$emit('sendmessage')
      this.resetTextarea();
    },
    
    updateValue (value) {
      this.$emit('input', value)
    },
  },

  watch: {
    value () {
      this.resizeTextarea()
    }
  }
};
</script>
